<template>
  <v-container>
    <div>
      <v-alert text dense color="deep-orange" icon="mdi-text-search" border="left">
        In order to see products, you need to add conditions to filter, then
        press <strong>Filter products</strong> button. If you want to see all
        products, just press <strong>Filter products</strong> button without any
        conditions added.
      </v-alert>
    </div>
    <div>
      <FilterForm @formatValues="formatFilterValues" :showButtons="true" ref="filterComponent"></FilterForm>
    </div>

    <v-divider class="my-2"></v-divider>

    <v-data-table class="mt-6" :headers="headers" :items="items" item-key="SKU" :single-expand="true"
      :expanded.sync="expanded" show-expand :search="search" dense :options.sync="options"
      :server-items-length="totalItems" :loading="loading" :footer-props="{
        'items-per-page-options': [50, 100, 150, 200, 500],
      }" height="65vh" fixed-header v-model="selectedProducts" show-select>
      <template v-slot:top>
        <v-row class="pb-1">
          <v-col cols="2" v-if="selectedProducts.length > 0">
            <v-btn :loading="loadingExportStateChange" color="green" outlined small @click="transferToDescribed"><v-icon
                left> mdi-export-variant </v-icon>
              Transfer to Not Exported list
              <v-icon v-if="transferDone || transferFailed" :color="transferDone ? 'green' : 'error'" right>
                {{ transferDone ? "mdi-check-circle" : "alert-circle" }}
                mdi-check-circle</v-icon>
            </v-btn>
          </v-col>

          <v-spacer></v-spacer>
          <v-col cols="6" class="pl-0">
            <v-text-field v-model="search" label="Search" class="mx-4" outlined dense
              hide-details="auto"></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.Photos`]="{ item }">
        <tr v-for="(itm, p) in item.Photos" :key="p">
          <td v-if="p === 0">
            <v-img max-width="100px" :src="itm"></v-img>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.Brand`]="{ item }">
        <tr>
          <td>
            <span>{{ item.Brand }}</span><br />
            <span class="grey--text"> Currency: {{ item.Currency }} </span>
          </td>
        </tr>
      </template>
      <template v-slot:[`item.stock`]="{ item }">
        <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
          {{ item.stock }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" size="40" @click="openHistory(item)" color="accent">mdi-eye-circle</v-icon>
          </template>
          <span>View product history</span>
        </v-tooltip>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <ProductInfo :product="item"></ProductInfo>
        </td>
      </template>
    </v-data-table>

    <ProductHistoryDialog :product="productForHistory" ref="productHistoryDialog"></ProductHistoryDialog>
  </v-container>
</template>

<script>
import FilterForm from "@/components/organisms/FilterForm.vue";
import ProductInfo from "../organisms/ProductInfo.vue";
import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";
export default {
  name: "LegacyData",
  props: {},
  components: {
    FilterForm,
    ProductInfo,
    ProductHistoryDialog,
  },
  data: () => ({
    headers: [
      { text: "PHOTO", value: "Photos", class: "footer" },
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "BARCODE", value: "Barcode", class: "footer" },
      { text: "CATEGORY", value: "Category", class: "footer" },
      { text: "CONDITION", value: "Condition", class: "footer" },
      { text: "BRAND", value: "Brand", class: "footer" },
      { text: "RRP", value: "RRP", class: "footer" },
      { text: "STOCK", value: "stock", class: "footer" },
      { text: "HISTORY", value: "actions", class: "footer" },
    ],
    items: [],
    expanded: [],
    loadingProducts: false,
    search: "",
    productForHistory: {},
    selectedProducts: [],
    loadingExportStateChange: false,
    transferDone: false,
    transferFailed: false,
    errorMsg: "",
    // NEW PROPERTIES FOR PAGINATION
    options: {},
    totalItems: 0,
    currentFilters: [],
    loading: false,
  }),
  watch: {
    options: {
      handler() {
        if (this.currentFilters.length > 0) {
          this.filterProducts(this.currentFilters);
        }
      },
      deep: true,
    },
  },
  methods: {
    async transferToDescribed() {
      let skuArray = [];
      skuArray = this.selectedProducts.map((el) => {
        let sku = el.SKU;
        return sku;
      });
      let data = {
        skus: skuArray,
      };
      this.loadingExportStateChange = true;
      try {
        await this.$store.dispatch("changeStateToNotExported", data);

        this.loadingExportStateChange = false;
        this.transferDone = true;
        this.items = [];
        this.selectedProducts = [];
        this.$refs.filterComponent.formatValues();
      } catch (error) {
        this.loadingExportStateChange = false;
        this.transferDone = false;
        this.transferFailed = true;
        console.log(error);
        this.errorMsg = error.response.data
          ? error.response.data
          : "Something went wrong. Please contact tech team.";
      }
    },
    openHistory(item) {
      this.productForHistory = item;
      this.$refs.productHistoryDialog.showDialog(item);
    },
    // formatFilterValues(filters) {
    //   this.items = [];
    //   let finalData = {
    //     productFilters: [],
    //     actionFilters: [],
    //   };
    //   this.$refs.filterComponent.setLoading(true);
    //   finalData.productFilters.push(["ExportState", "equals", "Legacy"]);
    //   if (filters.length > 0) {
    //     for (let obj of filters) {
    //       if (obj.condition == "Yes") {
    //         obj.value = true;
    //       }
    //       if (obj.condition == "No") {
    //         obj.value = false;
    //       }
    //       if (obj.property["type"] === "Number") {
    //         obj.value = parseInt(obj.value);
    //       }
    //       if (obj.property.name == "Action date") {
    //         finalData.actionFilters.push([
    //           "date",
    //           obj.condition,
    //           new Date(obj.value),
    //         ]);
    //       }
    //       if (obj.property.name == "Action name") {
    //         finalData.actionFilters.push(["action", obj.condition, obj.value]);
    //       }
    //       if (obj.property.name == "User for action") {
    //         let surnames = [];
    //         obj.value.forEach((el) => {
    //           surnames.push(el.split(" ")[1]);
    //         });
    //         finalData.actionFilters.push(["lastName", obj.condition, surnames]);
    //       }
    //       if (
    //         obj.property.name != "Action name" &&
    //         obj.property.name != "Action date" &&
    //         obj.property.name != "User for action"
    //       ) {
    //         finalData.productFilters.push([
    //           obj.property.name,
    //           obj.condition,
    //           obj.value,
    //         ]);
    //       }
    //     }
    //   }
    //   this.filterProducts(finalData);
    // },
    formatFilterValues(filters) {
      let finalData = [];
      let val = "";
      this.$refs.filterComponent.setLoading(true);

      finalData.push(["ExportState", "equals", "Legacy"]);

      if (filters.length > 0) {
        for (let obj of filters) {
          if (obj.condition == "Yes") {
            val = true;
          } else if (obj.condition == "No") {
            val = false;
          } else if (obj.property["type"] === "Number") {
            val = parseInt(obj.value);
          } else if (obj.property["type"] === "Array") {
            val = obj.value;
          } else {
            val = obj.value;
          }
          finalData.push([obj.property["name"], obj.condition, val]);
        }
      }

      // NEW: Store filters for pagination
      this.currentFilters = finalData;
      this.filterProducts(finalData);
    },
    filterProducts(data) {
      // NEW: Get pagination params
      const { page, itemsPerPage } = this.options;

      // NEW: Set loading state
      this.loading = true;

      this.$store
        .dispatch("filterProducts", {
          filters: data,
          page: page || 1,
          limit: itemsPerPage || 100
        })
        .then((response) => {
          // NEW: Handle new response format
          if (response.data.data) {
            this.items = response.data.data;
            this.totalItems = response.data.pagination?.total || response.data.data.length;
          } else {
            // Fallback for old format
            this.items = response.data;
            this.totalItems = response.data.length;
          }

          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
        })
        .catch((error) => {
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
          let errorMsg = "";
          errorMsg = error.response.data
            ? error.response.data
            : "Something went wrong while filtering.";
          this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
          console.log(error);
        });
    },
  },
};
</script>